import LockIcon from "@mui/icons-material/Lock";
import { Box } from "@mui/material";



export function ShieldIcon() {
    return (
        <Box
            sx={{
                mb: 2,
                position: "relative",
                width: 100,
                height: 100,
                display: "inline-flex",
                alignItems: "center",
                justifyContent: "center",
                flexShrink: 0,
            }}
        >
            <Box
                sx={{
                    width: "100px",
                    height: "100px",
                    background: "linear-gradient(180deg, #FFD900 0%, #FB8E00 100%)",
                    mask: `url("data:image/svg+xml;utf8,<svg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 24 24'><path fill='white' d='M12 1L3 5v6c0 5.55 3.84 10.74 9 12 5.16-1.26 9-6.45 9-12V5l-9-4z'/></svg>") no-repeat center`,
                    WebkitMask: `url("data:image/svg+xml;utf8,<svg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 24 24'><path fill='white' d='M12 1L3 5v6c0 5.55 3.84 10.74 9 12 5.16-1.26 9-6.45 9-12V5l-9-4z'/></svg>") no-repeat center`,
                    maskSize: "contain",
                    WebkitMaskSize: "contain",
                    flexShrink: 0,
                }}
            />
            {/* Candado encima */}
            <LockIcon
                sx={{
                    position: "absolute",
                    fontSize: 42,
                    color: "white",
                }}
            />
        </Box>
    )
}

